export enum EFeedbackType {
  COMPLIMENT = 'Elogio',
  SUGGESTION = 'Sugestão'
}

export interface IFeedbackValues {
  type: EFeedbackType
  feedback: string
}

export interface IFeedbackResponse {
  userFeedbackId: string
}
